import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Navbar from './navbar';
import reportWebVitals from './reportWebVitals';
import Sidebar from './sidebar';
import Footer from './footer';
import $ from 'jquery';
import MemberHub from './member/MemberHub';
import { QuickDock } from './member/MemberUI';
import { useLang } from './site/i18n';

import { installLinkInterceptor } from './site/nav';

// คลิกลิงก์ภายในเว็บ = เปลี่ยนหน้าทันทีไม่ reload
installLinkInterceptor();

// เปลี่ยนภาษา/ชื่อเว็บ -> render ใหม่ในที่เดิม (ไม่ mount ใหม่ ข้อมูลไม่หาย ไม่โหลด API ซ้ำ)
function LangRoot({ component: C }) {
  const { lang, site } = useLang();
  return <C lang={lang} site={site} />;
}


if (process.env.NODE_ENV === "production")
  console.log = function no_console() { };

const sidebar = ReactDOM.createRoot(document.getElementById('sidebar'));
sidebar.render(
  <>
    <LangRoot component={Sidebar} />
  </>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
      <LangRoot component={App} />
  </>
);

const navbar = ReactDOM.createRoot(document.getElementById('navbar'));
navbar.render(
  <>
      <LangRoot component={Navbar} />
  </>
);

// ระบบสมาชิก (ฝาก ถอน ชวนเพื่อน กงล้อ เช็คอิน ฯลฯ) — root แยกของตัวเอง
let memberhubEl = document.getElementById('memberhub');
if (!memberhubEl) {
  memberhubEl = document.createElement('div');
  memberhubEl.id = 'memberhub';
  document.body.appendChild(memberhubEl);
}
ReactDOM.createRoot(memberhubEl).render(
  <>
    <MemberHub />
    <QuickDock />
  </>
);

const footer = ReactDOM.createRoot(document.getElementById('footer'));
footer.render(
  <>
    <LangRoot component={Footer} />
  </>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(////console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
